export const OETarget = {
    animalCell:                                 'animalCell',
    animalSnail:                                'animalSnail',
    hoofCarpal:                                 'hoofCarpal',
    hoofDynamics:                               'hoofDynamics',
    hoofMicro:                                  'hoofMicro',
    hoofVessels:                                'hoofVessels',
    hoofWeb:                                    'hoofWeb',
    humanAbdominalWall:                         'humanAbdominalWall',
    humanAnkleFoot:                             'humanAnkleFoot',
    humanArm:                                   'humanArm',
    humanArmPathways:                           'humanArmPathways',
    humanBodyMuscles:                           'humanBodyMuscles',
    humanBrainNeuron:                           'humanBrainNeuron',
    humanBrainSynapse:                          'humanBrainSynapse',
    humanCellEpithelium:                        'humanCellEpithelium',
    humanChestWall:                             'humanChestWall',
    humanCranialNerves:                         'humanCranialNerves',
    humanEarMacro:                              'humanEarMacro',
    humanEarMicro:                              'humanEarMicro',
    humanElbow:                                 'humanElbow',
    humanEye:                                   'humanEye',
    humanEye2:                                  'humanEye2',
    humanEyeCornea:                             'humanEyeCornea',
    humanEyeMacro:                              'humanEyeMacro',
    humanEyeMicro:                              'humanEyeMicro',
    humanEyeOCT:                                'humanEyeOCT',
    humanEyeRetina:                             'humanEyeRetina',
    humanFoot:                                  'humanFoot',
    humanForearm:                               'humanForearm',
    humanHand:                                  'humanHand',
    humanHead:                                  'humanHead',
    humanHeadLeFx:                              'humanHeadLeFx',
    humanHeadWIP:                               'humanHeadWIP',
    humanHeart:                                 'humanHeart',
    humanHip:                                   'humanHip',
    humanHip2:                                  'humanHip2',
    humanKnee:                                  'humanKnee',
    humanKneeImplantcast:                       'humanKneeImplantcast',
    humanLarynx:                                'humanLarynx',
    humanLeg:                                   'humanLeg',
    humanLegPathways:                           'humanLegPathways',
    humanLiverMicro:                            'humanLiverMicro',
    humanLowerLeg:                              'humanLowerLeg',
    humanNeckBack:                              'humanNeckBack',
    humanPelvis:                                'humanPelvis',
    humanShoulder:                              'humanShoulder',
    humanShoulderGirdle:                        'humanShoulderGirdle',
    humanSkin:                                  'humanSkin',
    humanSkin2:                                 'humanSkin2',
    humanSkinMacro:                             'humanSkinMacro',
    humanSkinMacroLR:                           'humanSkinMacroLR',
    humanSkinMicro:                             'humanSkinMicro',
    humanSkinEpidermis:                         'humanSkinEpidermis',
    humanSkull:                                 'humanSkull',
    humanSpine:                                 'humanSpine',
    humanSpineFracture:                         'humanSpineFracture',
    humanThighKnee:                             'humanThighKnee',
    humanTrunk:                                 'humanTrunk',
    humanUpperArmElbow:                         'humanUpperArmElbow',
    implantcastACSMB4in1:                       'implantcastACSMB4in1',
    implantcastACSSCFB:                         'implantcastACSSCFB',
    implantcastACSSCMB:                         'implantcastACSSCMB',
    implantcastActiniaStem:                     'implantcastActiniaStem',
    implantcastAGILONGlenoidzementfrei:         'implantcastAGILONGlenoidzementfrei',
    implantcastAGILONMI:                        'implantcastAGILONMI',
    implantcastAGILONOmarthrosisLongFit:        'implantcastAGILONOmarthrosisLongFit',
    implantcastAgilonPEGlenoid:                 'implantcastAgilonPEGlenoid',
    implantcastAGILONTraumalongfit:             'implantcastAGILONTraumalongfit',
    implantcastAidaShortStem:                   'implantcastAidaShortStem',
    implantcastDeltopectoralApproach:           'implantcastDeltopectoralApproach',
    implantcastDirectAnteriorApproach:          'implantcastDirectAnteriorApproach',
    implantcastEcoFit2M:                        'implantcastEcoFit2M',
    implantcastEcoFit2MSP:                      'implantcastEcoFit2MSP',
    implantcastEcoFitCup:                       'implantcastEcoFitCup',
    implantcastEcoFitCupEPORE:                  'implantcastEcoFitCupEPORE',
    implantcastEcoFitHipStem:                   'implantcastEcoFitHipStem',
    implantcastEcoFitHipStem123:                'implantcastEcoFitHipStem123',
    implantcastEcoFitHipStem133123:             'implantcastEcoFitHipStem133123',
    implantcastEcoFitSC:                        'implantcastEcoFitSC',
    implantcastEcoFitShortStem:                 'implantcastEcoFitShortStem',
    implantcastMutarsDistFemurMK:               'implantcastMutarsDistFemurMK',
    implantcastMutarsDistFemurRS:               'implantcastMutarsDistFemurRS',
    implantcastMUTARSGenuXMK:                   'implantcastMUTARSGenuXMK',
    implantcastMutarsHumerusInvers:             'implantcastMutarsHumerusInvers',
    implantcastMUTARSKRIMK:                     'implantcastMUTARSKRIMK',
    implantcastMutarsLumic:                     'implantcastMutarsLumic',
    implantcastMUTARSModularStem:               'implantcastMUTARSModularStem',
    implantcastMutarsProxFemur:                 'implantcastMutarsProxFemur',
    implantcastMutarsProxHumerus:               'implantcastMutarsProxHumerus',
    implantcastMUTARSProxTibiaMK:               'implantcastMUTARSProxTibiaMK',
    implantcastMUTARSPRS:                       'implantcastMUTARSPRS',
    implantcastMutarsRS:                        'implantcastMutarsRS',
    implantcastMutarsRSArthrodesisImplant:      'implantcastMutarsRSArthrodesisImplant',
    implantcastMutarsTorqueWrench:              'implantcastMutarsTorqueWrench',
    implantcastMutarsTotalesFemurMK:            'implantcastMutarsTotalesFemurMK',
    implantcastPEcupMuellerII:                  'implantcastPEcupMuellerII',
    implantcastShoulderApproachAnterior:        'implantcastShoulderApproachAnterior',
    implantcastTestTarget:                      'implantcastTestTarget',
    plantCell:                                  'plantCell',
    sensorySystems:                             'sensorySystems',
    sensorySystemsEar:                          'sensorySystemsEar',
    sensorySystemsEye:                          'sensorySystemsEye',
    thiemeSkull:                                'thiemeSkull',
    toxnetz:                                    'toxnetz',
    void:                                       'void',
    xRayExplorer:                               'xRayExplorer',
    xRayIcarus:                                 'xRayIcarus',
    zeissOpti:                                  'zeissOpti',
    zeissOpti2:                                 'zeissOpti2',
    zeissUV:                                    'zeissUV',
//  @ADD_TARGET_ALL_TARGETID
    schoolAtomicModel              : 'schoolAtomicModel',
    xRayUpperExtremityMobile       : 'xRayUpperExtremityMobile',
    xRayTrunkMobile                : 'xRayTrunkMobile',
    xRayLowerExtremityMobile       : 'xRayLowerExtremityMobile',
    schoolGeometrie                : 'schoolGeometrie',
    thiemeShoulderGirdleAnimation  : 'thiemeShoulderGirdleAnimation',
    xRayTrunk                      : 'xRayTrunk',
    xRayUpperExtremity             : 'xRayUpperExtremity',
    xRayLowerExtremity             : 'xRayLowerExtremity',
    thiemeEyeAnimation             : 'thiemeEyeAnimation',
    humanEyeAmetropia              : 'humanEyeAmetropia',
    surgeryOHSTPrimaCurve          : 'surgeryOHSTPrimaCurve',
    sportShoulderGirdle            : 'sportShoulderGirdle',
    schoolCellDivision             : 'schoolCellDivision',
    schoolSkull                    : 'schoolSkull',
    schoolRefrigerator             : 'schoolRefrigerator',
    schoolVolcano                  : 'schoolVolcano',
    schoolToxin                    : 'schoolToxin',
    humanBonesSchool               : 'humanBonesSchool',
    humanBones                     : 'humanBones',
    schoolSolarSystem              : 'schoolSolarSystem',
    humanRespiratoryEpithelium     : 'humanRespiratoryEpithelium',
    humanMuscleSpindle             : 'humanMuscleSpindle',
    humanBronchialTree             : 'humanBronchialTree',
    humanRespiratorySystem         : 'humanRespiratorySystem',
    humanGenitalMale               : 'humanGenitalMale',
    thiemeLarynxAnimation:                      'thiemeLarynxAnimation',
    virusSarscov2:                              'virusSarscov2',
    schoolSouthAmerica:                         'schoolSouthAmerica',
    schoolFormelsammlung:                       'schoolFormelsammlung',
    thiemeEarMacro:                             'thiemeEarMacro',
    thiemeEarInner:                             'thiemeEarInner',
    techEngineOtto:                             'techEngineOtto',
    surgeryLinkEmbrace :                        'surgeryLinkEmbrace',
    surgeryBbraunOneKnee:                       'surgeryBbraunOneKnee',
    thiemeCNS:                                  'thiemeCNS',
    surgeryIdo:                                 'surgeryIdo',
    humanCNSWIP:                                'humanCNSWIP',
    surgeryAppendix:                            'surgeryAppendix',
    humanEyeMuellerCell:                        'humanEyeMuellerCell',
    humanTrunkVessel:                           'humanTrunkVessel',
    humanSpineFracture2:                        'humanSpineFracture2',
    humanPatient:                               'humanPatient',
    humanCNS:                                   'humanCNS',
    humanEarInner:                              'humanEarInner',
    humanEyeMembrane:                           'humanEyeMembrane',
    humanEyeOcclusion:                          'humanEyeOcclusion',
    surgeryEyeCataract:                         'surgeryEyeCataract',
    humanHeadreduced1:                          'humanHeadreduced1',
    implantcastDemoMutarsKRIMK:                 'implantcastDemoMutarsKRIMK',
    humanEyeLid:                                'humanEyeLid',
    implantcastHAPTic:                          'implantcastHAPTic',
    humanLiverEnzyme2:                          'humanLiverEnzyme2',
    humanEyeDMOE:                               'humanEyeDMOE',
    humanLiverEnzyme:                           'humanLiverEnzyme',
    humanForearmDemo:                           'humanForearmDemo',
    humanBrainPotential:                        'humanBrainPotential',
    implantcastICARA:                           'implantcastICARA',
    implantcastCarpoFit:                        'implantcastCarpoFit',
    implantcastIntramedullaryPlug:              'implantcastIntramedullaryPlug',
    implantcastHipDorsalApproach:               'implantcastHipDorsalApproach',
    implantcastKneeMedialParapatellarApproach:  'implantcastKneeMedialParapatellarApproach',
    implantcastKneeLateralParapatellarApproach: 'implantcastKneeLateralParapatellarApproach',
    thiemeEye2:                                 'thiemeEye2',
    thiemeEyeRetina:                            'thiemeEyeRetina',
    thiemeTrunk:                                'thiemeTrunk',
    thiemeSpine:                                'thiemeSpine',
    thiemeNeckBack:                             'thiemeNeckBack',
    thiemeChestWall:                            'thiemeChestWall',
    thiemeAbdominalWall:                        'thiemeAbdominalWall',
    thiemeCranialNerves:                        'thiemeCranialNerves',
    thiemeHead:                                 'thiemeHead',
    thiemeLarynx:                               'thiemeLarynx',
    thiemePelvis:                               'thiemePelvis',
    thiemeThighKnee:                            'thiemeThighKnee',
    thiemeLowerLeg:                             'thiemeLowerLeg',
    thiemeLeg:                                  'thiemeLeg',
    thiemeHip2:                                 'thiemeHip2',
    thiemeAnkleFoot:                            'thiemeAnkleFoot',
    humanBrainACh:                              'humanBrainACh',
    humanLiverSinusoid:                         'humanLiverSinusoid',
    implantcastMutarsRScup:                     'implantcastMutarsRScup',
    implantcastEporeMetaphysealComponentsGenuX: 'implantcastEporeMetaphysealComponentsGenuX',
    thiemeArm:                                  'thiemeArm',
    thiemeUpperArmElbow:                        'thiemeUpperArmElbow',
    thiemeShoulderGirdle:                       'thiemeShoulderGirdle',
    thiemeForearm:                              'thiemeForearm',
    thiemeHand:                                 'thiemeHand',
    implantcastMutarsProxFemurDiaphyse:         'implantcastMutarsProxFemurDiaphyse',
    implantcasticStraightStem:                  'implantcasticStraightStem',
    implantcastMutarsProxFemurRevision:         'implantcastMutarsProxFemurRevision',
    implantcastDiaLocRS:                        'implantcastDiaLocRS',
    toxnetzFormelsammlung:                      'toxnetzFormelsammlung',
    materialTestTarget:                         'materialTestTarget',
    implantcastMutarsTotalHumerus:              'implantcastMutarsTotalHumerus',
    implantcastMutarsDistHumerus30mm:           'implantcastMutarsDistHumerus30mm',
    implantcastACSUniFB:                        'implantcastACSUniFB',
    effigosExplorerHelp:                        'effigosExplorerHelp',
    implantcastEporeConeKRIundRSArthrodese:     'implantcastEporeConeKRIundRSArthrodese',
    implantcastEporeConesCortical:              'implantcastEporeConesCortical',
    implantcastMutarsDiaphysealImplant:         'implantcastMutarsDiaphysealImplant',
    implantcastMutarsProxFemurRS:               'implantcastMutarsProxFemurRS',
    implantcastACSMBAllinOne:                   'implantcastACSMBAllinOne',
    implantcastMutarsDistHumerus50mm:           'implantcastMutarsDistHumerus50mm',
    implantcastMutarsTotalKneeKRIMK:            'implantcastMutarsTotalKneeKRIMK',
    implantcastMutarsTotalKneeMK:               'implantcastMutarsTotalKneeMK',
    implantcastMutarsIntramedtotalFemurMK:      'implantcastMutarsIntramedtotalFemurMK',
    implantcastMutarsHumerusDiaphysealImplant:  'implantcastMutarsHumerusDiaphysealImplant',
    implantcastACSUniSG:                        'implantcastACSUniSG',
    implantcastEporeConesMetaphyseal:           'implantcastEporeConesMetaphyseal',
    implantcastMutarsTotalElbow:                'implantcastMutarsTotalElbow',
    implantcastACSFBAllinOne:                   'implantcastACSFBAllinOne',
    humanEyeAMD:                                'humanEyeAMD',
    implantcastMutarsIntramedtotalFemurGenuX:   'implantcastMutarsIntramedtotalFemurGenuX',
    implantcastMutarsArthrodesisimplant:        'implantcastMutarsArthrodesisimplant',
    humanBrainMembrane:                         'humanBrainMembrane',
    implantcastMutarsProxUlnaLongFit:           'implantcastMutarsProxUlnaLongFit',
};

export const OEResourceTarget = Object.assign({
    amboss:                     'amboss',
    anatomy:                    'anatomy',
    bbraun:                     'bbraun',
    cell:                       'cell',
    demoRes:                    'demoRes',
    hoof:                       'hoof',
    humanEarRes:                'humanEarRes',
    humanEyeRes:                'humanEyeRes',
    humanSkinRes:               'humanSkinRes',
    implantcast:                'implantcast',
    ortho:                      'ortho',
    santen:                     'santen',
    school:                     'school',
    science:                    'science',
    sport:                      'sport',
    surgery:                    'surgery',
    thieme:                     'thieme',
    toxnetzRes:                 'toxnetzRes',
    xRayRes:                    'xRayRes',
    xRayMinRes:                 'xRayMinRes',
    xRayIcarusRes:              'xRayIcarusRes',
    zeiss:                      'zeiss',

    isResourceTarget: function(target)  {
        if(!this.allResourceTargets)    {
            this.allResourceTargets = [
                OEResourceTarget.amboss,
                OEResourceTarget.anatomy,
                OEResourceTarget.bbraun,
                OEResourceTarget.cell,
                OEResourceTarget.demoRes,
                OEResourceTarget.hoof,
                OEResourceTarget.humanEarRes,
                OEResourceTarget.humanEyeRes,
                OEResourceTarget.humanSkinRes,
                OEResourceTarget.implantcast,
                OEResourceTarget.ortho,
                OEResourceTarget.santen,
                OEResourceTarget.school,
                OEResourceTarget.science,
                OEResourceTarget.sport,
                OEResourceTarget.surgery,
                OEResourceTarget.thieme,
                OEResourceTarget.toxnetzRes,
                OEResourceTarget.xRayRes,
                OEResourceTarget.xRayMinRes,
                OEResourceTarget.xRayIcarusRes,
                OEResourceTarget.zeiss,
            ];
        }
        return this.allResourceTargets.includes(target);
    },

    defaultTargetForResourceTarget: function(target)    {
        switch(target)  {
            case OEResourceTarget.amboss:           return OETarget.humanTrunk;
            case OEResourceTarget.anatomy:          return OETarget.humanSkull;
            case OEResourceTarget.bbraun:           return OETarget.surgeryBbraunOneKnee;
            case OEResourceTarget.cell:             return OETarget.animalCell;
            case OEResourceTarget.demoRes:          return OETarget.effigosExplorerHelp;
            case OEResourceTarget.hoof:             return OETarget.hoofWeb;
            case OEResourceTarget.humanEarRes:      return OETarget.humanEarMacro;
            case OEResourceTarget.humanEyeRes:      return OETarget.humanEye2;
            case OEResourceTarget.humanSkinRes:     return OETarget.humanSkinMacro;
            case OEResourceTarget.implantcast:      return OETarget.humanKneeImplantcast;
            case OEResourceTarget.ortho:            return OETarget.humanHead;
            case OEResourceTarget.school:           return OETarget.humanBrainSynapse;
            case OEResourceTarget.science:          return OETarget.humanEyeRetina;
            case OEResourceTarget.sport:            return OETarget.humanShoulderGirdle;
            case OEResourceTarget.thieme:           return OETarget.thiemeSkull;
            case OEResourceTarget.surgery:          return OETarget.implantcastHipDorsalApproach;
            case OEResourceTarget.toxnetzRes:       return OETarget.toxnetz;
            case OEResourceTarget.xRayRes:          return OETarget.xRayLowerExtremity;
            case OEResourceTarget.xRayMinRes:       return OETarget.xRayLowerExtremityMobile;
            case OEResourceTarget.xRayIcarusRes:    return OETarget.xRayIcarus;
            case OEResourceTarget.zeiss:            return OETarget.zeissOpti2;
        }
        return target;
    }

}, OETarget);